import React from 'react'

export default function Shop() {
    return (
        <div>
            WELCOME TO SHOP
        </div>
    )
}
